export const PolicyModel = {
  policyNo: "",
  effDate: "",
  priorPolicyNo: "",
  expDate: "",
  previousExpDate: "",
  dateBound: "",
  policyStatus: "",
  previousCompany: "",
  apprBy: "",
  hasLapseNone: null,
  hasLapse110: false,
  hasLapse1131: false,
  hasPriorCoverage: "",
  hasPriorBalance: false,
  hasBI: false,
  ins1First: "",
  ins2First: "",
  garageAddress: "",
  garageCity: "",
  garageState: "",
  garageCounty: "",
  garageStreet: "",
  garageTerritory: "",
  homePhone: "",
  ins1MI: "",
  ins2MI: "",
  isAnnual: false,
  mailCity: "",
  mailGarageSame: true,
  mainState: "",
  mailState: "",
  mailStreet: "",
  mailZip: "",
  mainEmail: "",
  paperless: false,
  isPaperless: false,
  workPhone: "",
  garageZip: "",
  altEmail: "",
  creditScore: 0,
  priorBI: "",
  territory: "",
};

export const PolicyWarningModel = {
  misrep: false,
  noREI: false,
  onHoldL: false,
  returnedMail: false,
  suspense: false,
  ensf: false,
};
export const CreateWarningModel = {
  misrep: false,
  noREI: false,
  onHold: false,
  policyNo: "",
  returnedMail: false,
  suspense: false,
  ensf: false,
};

export const tempDriverModel = {
  policyNo: "",
  driverIndex: null,
  firstName: "",
  lastName: "",
  mi: "",
  suffix: null,
  dob: null,
  gender: "",
  married: false,
  relationToInsured: "",
  licenseStatus: null,
  licenseNo: "",
  dateLicensed: null,
  internationalLic: false,
  suspLic: false,
  unverifiable: false,
  isIneligible: false,
  sr22CaseNo: null,
  sr22: false,
  seniorDefDrvDisc: false,
  safeDriver: false,
  inceptionDate: null,
  exclude: false,
  jobTitle: null,
  company: "",
  companyAddress: null,
  companyState: null,
  companyZip: null,
  companyCity: null,
  workPhone: null,
  chargeMVR: false,
  points: 0,
  licenseSt: "FL",
  isDriverUnacceptableRisk: false,
  creditScore: 0,
  policyDriverViolations: [],
  isChangeStatus: false,
  // ars: "NO",
  // biSymbol: null,
};

export const DriverModel = {
  chargeMVR: false,
  classs: "",
  company: "",
  companyAddress: null,
  companyCity: null,
  companyState: null,
  companyZip: null,
  dateLicensed: "",
  deleted: false,
  dlType: null,
  dob: "",
  driverAge: null,
  driverIndex: null,
  driverMsg: null,
  effDate: null,
  exclude: false,
  expDate: null,
  firstName: "",
  gcRecord: null,
  gender: "",
  hasMvr: false,
  inceptionDate: null,
  inexp: false,
  internationalLic: false,
  isExpiredLicense: null,
  isLearners: null,
  jobTitle: null,
  lastName: "",
  licenseExpiration: null,
  licenseNo: "",
  licenseSt: "FL",
  licenseStatus: null,
  married: false,
  mi: "",
  occupation: "",
  oid: null,
  optimisticLockField: null,
  points: null,
  policyNo: "",
  primarycar: null,
  ptsDriverIndex: null,
  relationToInsured: "",
  safeDriver: false,
  seniorDefDrvDate: "",
  seniorDefDrvDisc: false,
  sr22: false,
  sr22CaseNo: null,
  sr22PrintDate: null,
  sr26PrintDate: null,
  ssn: null,
  suffix: null,
  suspLic: false,
  unverifiable: false,
  violations: null,
  workPhone: null,
  youthful: false,
  policyDriverViolations: [],
  isLocal: false,
  creditScore: 0,
};

export const VehicleModel = {
  abs: 0,
  absDiscAmt: null,
  atd: null,
  amountCustom: null,
  apcDiscAmt: null,
  arb: null,
  arbDiscAmt: null,
  artisan: false,
  atdDiscAmt: null,
  biAnnlPrem: null,
  biSymbol: null,
  biWritten: null,
  businessUse: false,
  carIndex: null,
  collSymbol: null,
  collWritten: null,
  compSymbol: null,
  compWritten: null,
  costNew: null,
  deleted: false,
  directRepairDiscAmt: null,
  effDate: null,
  expDate: null,
  farmUse: false,
  homeDiscAmt: null,
  inexpSurgAmt: null,
  internationalSurgAmt: null,
  isoPhyDamSymbol: null,
  isoSymbol: null,
  mcDiscAmt: null,
  milesToWork: null,
  mpAnnlPrem: null,
  mpSymbol: null,
  mpWritten: null,
  noHitSurgAmt: null,
  oid: null,
  oosLicSurgAmt: null,
  pdAnnlPrem: null,
  pdSymbol: null,
  pdWritten: null,
  pipAnnlPrem: null,
  pipSymbol: null,
  pipWritten: null,
  pointSurgAmt: null,
  policyNo: null,
  princOpr: null,
  priorBalanceSurgAmt: null,
  rateCycle: null,
  ratedOpr: null,
  ratingClass: null,
  renDiscAmt: null,
  sdDiscAmt: null,
  ssdDiscAmt: null,
  totalPoints: null,
  transferDiscAmt: null,
  umSymbol: null,
  umWritten: null,
  unacceptSurgAmt: null,
  vehCylinders: null,
  vehDoors: null,
  vehDriveType: null,
  vehMake: null,
  vehModel1: null,
  vehModel2: null,
  vehYear: null,
  vin: null,
  vinIndex: null,
  wlDiscAmt: null,
  convTT: false,
  is4wd: false,
  isDRL: false,
  isHybrid: false,
  isVinValid: false,
  hasPhyDam: false,
  isLocal: false,
  hasComp: false,
  compDed: "",
  classCode: "",
  collDed: "",
  ars: "NO",
  isIneligible: false,
  isForceSymbols: false,
  isChangeStatus: false,
  policyCarLienHolders: [
    {
      lienHolderIndex: 1,
      name: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      isAddInterest: false,
      isNonInstitutional: false,
      dateCreated: null,
    },
    {
      lienHolderIndex: 2,
      name: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      isAddInterest: false,
      isNonInstitutional: false,
      dateCreated: null,
    },
  ],
};

export const LeinHoldersModel = {
  address: null,
  carIndex: null,
  city: null,
  isAddInterest: false,
  name: null,
  phone: null,
  state: null,
  zip: null,
};

export const NoteModel = {
  diary: false,
  manager: true,
  notes: null,
  policyNo: null,
  date: new Date(),
  time: 0,
};
export const FooterModel = {
  eftDisc: null,
  hasLapseNone: false,
  hasPriorBalance: false,
  hasPriorCoverage: false,
  homeowner: false,
  maintenanceFee: null,
  mvrFee: null,
  paidInFullDisc: false,
  pipPDOnlyFee: null,
  policyFee: null,
  policyTotal: null,
  rateCycle: null,
  ratingCarList: [],
  renDisc: false,
  sr22Fee: null,
  territory: null,
  totalFees: null,
  ratingTier: null,
  debugRating: false,
  differnce: 0,
  lapseSurchange: null,
  transferDiscount: false,
};
export const ProducerModel = {
  agencyName: null,
  agentCode: null,
  county: null,
  dateOpened: null,
  emailAddress: null,
  fax: null,
  isOwnerOperator: false,
  isPaperless: false,
  phone: null,
  physicalCity: null,
  physicalState: null,
  physicalZIP: null,
  // status: null,
  website: null,
};
export const PremiumModel = {
  advancedQuote: false,
  biLimit: null,
  collDed: null,
  compDed: null,
  eft: false,
  transDisc: null,
  hasPPO: false,
  homeowner: false,
  isCurrentCustomer: false,
  nio: false,
  nirr: false,
  paidInFullDisc: false,
  paymentPlan: null,
  pipDed: null,
  renDisc: false,
  umLimit: null,
  workLoss: false,
  isPaperless: false,
};
export const ApDataModel = {
  isSuspenseForPrint: false,
  policyNo: null,
  reasons: [],
};
export const apReasonDataModal = {
  apreasonFormData: [
    {
      indexId: null,
      policyNo: null,
      reason1: null,
    },
    {
      indexId: null,
      policyNo: null,
      reason1: null,
    },
  ],
};
export const SuspenseDataModel = {
  cancel: false,
  index: null,
  indexDesc: null,
  policyNo: null,
  reason: null,
  status: null,
};
export const UploadDocumentModel = {
  category: null,
  fileNo: null,
  formDesc: null,
  formType: null,
  dept: null,
  reportFile: null,
};
export const ReminderModel = {
  description: null,
  location: null,
  startTime: null,
  userName: "",
  time: null,
  remainderType: "",
};
export const SendDataModel = {
  fileName: null,
  sendToo: null,
  sendBy: null,
  message: null,
  indexId: null,
  agentEmail: null,
  agentFlag: null,
  applicantEmail: null,
  applicantFlag: null,
  sendTo: [],
};
export const EditDocModel = {
  category: null,
  claimant: null,
  dateProcessed: null,
  dept: null,
  fileNo: null,
  formDesc: null,
  formType: null,
  indexID: null,
  wfProcessed: null,
};
export const SearchVinModel = {
  policyNo: null,
  vin: null,
};

export const IssuePolicyModel = {
  cancelDate: null,
  cancellationType: null,
  mailDate: null,
  nsf: true,
  policyNo: null,
  reasons: [],
};

export const CancelPolicyModel = {
  cancelDate: null,
  policyNo: null,
  reasons: [],
  type: null,
};
export const PolicyHoldModel = {
  hasHoldReason: false,
  policyNo: null,
  reason: null,
};

export const SuspenseModel = {
  userName: "",
  policyNo: null,
  formDescriptions: [],
};
export const PrintDataModel = {
  date: null,
  hideImagingDiaries: false,
  page: 1,
  showCleared: false,
  size: 10,
  userName: null,
  userNameDiary: null,
};

export const policyDataModel = {
  policyInfo: {
    expDate: null,
    effDate: null,
  },
  agentResp: {
    insuredName: "",
    insuredPhone: "",
  },
};

export const SettingsModal = {
  description: "",
  reasonType: "",
  maintainceType: "",
};
export const searchResultModel = {
  effDate: null,
  policyStatus: "",
  agencyName: "",
  agentCode: "",
  agentPhoneNo: "",
  expDate: null,
  ins1FullName: "",
  diaryFlag: false,
  diaryList: [],
  warningsCount: 0,
  vehicalDetails: [],
  driverDetails: [],
};

export const BankInfoModel = {
  policyNumber: null,
  accountNumber: null,
  bankAccountName: null,
  aba: null,
  accountType: null,
  account: null,
};
export const PortalModel = {
  policyNo: null,
  minDuePayDate: null,
  isAllowRenPastExp: null,
  allowPymntWithin15Days: null,
};
export const BankInfoDeleteModal = {
  policyNumber: null,
  accountNumber: null,
  accountType: null,
};
export const PermissionModal = {
  department: null,
  longDesc: null,
  shortDesc: null,
};
export const AddRoleModal = {
  description: null,
  role: null,
};
export const BankInfoDataModal = {
  policyNo: null,
  fullName: null,
  street: null,
  city: null,
  state: null,
  zipCode: null,
  cardNo: null,
  expiry: null,
  cvv2: null,
  accttype: null,
  routingNo: null,
  isCreditCard: null,
};

export const LienModel = [
  {
    lienHolderIndex: 1,
    name: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    isAddInterest: false,
    isNonInstitutional: false,
    dateCreated: null,
  },
  {
    lienHolderIndex: 2,
    name: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    isAddInterest: false,
    isNonInstitutional: false,
    dateCreated: null,
  },
];
